import { i18nCasePage as caseTranslations } from './case.i18n';

export const i18nComponents = {
  table: {
    ALL: 'Seleccionar todo',
    '-': '(Vacío)',
  },
  notifications_manager: {
    tabs: {
      NEW: 'Agregar nuevo',
      LIST: 'Notificaciones',
      EDIT: 'Editar',
    },
    notifications_list: {
      toggle: 'Notificarme actualizaciones en Casos en los que soy titular',
    },
    select_asset: 'Seleccionar un activo',
    save: 'Guardar notificación',
    description: 'Ingrese una descripción para esta notificación',
    frequency: 'Frecuencias',
    select_frequency: 'Seleccionar frecuencias',
    frequency_options: {
      DAILY: 'A diario',
      MONDAYS: 'Lunes',
      TUESDAYS: 'Martes',
      WEDNESDAYS: 'Miércoles',
      THURSDAYS: 'Jueves',
      FRIDAYS: 'Viernes',
      SATURDAYS: 'Sábados',
    },
  },
  permissioned_button: {
    unauthorized:
      'No puede realizar esta acción debido a permisos limitados. Póngase en contacto con el administrador del sistema.',
  },
  downloadCSVButton: {
    tooltip: 'Descargue un archivo CSV con la lista a continuación',
  },
  scallingModels: {
    status: { high: 'Alto', low: 'Bueno', medium: 'Medio' },
    statusDetail: {
      HIGH: '(riesgo 0,75 a 1,00)',
      LOW: '(riesgo bajo 0,50)',
      MEDIUM: '(riesgo 0,50 a 0,75)',
    },
  },
  event_list: {
    id: 'Evento ID',
    asset_name: 'Equipo',
    classification: 'Clasificación',
    description: 'Descripción',
    model: 'Modelo',
    start_time: 'Horario',
    status: 'Estado',
    type: 'Tipo',
    filters: {
      asset: 'Equipo',
      copy: 'Copiar los elementos de la tabla al portapapeles',
      export_csv: 'Exportar los elementos de la tabla a un archivo CSV',
      period: 'Período',
      search: 'Buscar',
      copied_success: 'Los elementos de la tabla se copiaron al portapapeles',
    },
  },
  date_filter: {
    reference_date: 'Data de referencia',
    creation: 'Inicio',
    closing: 'Fin',
    period: 'Período',
    alarm: 'Alarma',
    alarm_period: 'Alarma actual',
    event_period: 'Evento actual',
    last_n_days: 'Últimos {{days}} días',
    last_n_hours: 'Últimas {{hours}} horas',
    max_period: 'Período máximo',
    all: 'Todos',
    custom: 'Disfraz',
    start_date: 'Comienzo',
    end_date: 'Término',
    real_time: 'En tiempo real',
    date: {
      lts: 'DD/MM/YYYY',
      datetime_minute: 'DD/MM/YYYY HH:mm',
      datetime_second: 'DD MMM HH:mm:ss',
      month_year: 'MMM/YYYY',
    },
    invalid_range: 'El intervalo debe ser menor de {{maxMonthsRange}} meses',
  },
  asset_card: {
    alarm: {
      alarm_zero: 'Sin alarmas',
      alarm_one: '{{count}} alarma',
      alarm_other: '{{count}} alarmas',
    },
    event: {
      event_zero: 'Sin eventos',
      event_one: '{{count}} evento',
      event_other: '{{count}} eventos',
    },
    sensor: {
      delayed: {
        delayed_zero: 'Sin sensores tardíos',
        delayed_one: '{{count}} sensor tardío',
        delayed_other: '{{count}} sensores tardíos',
      },
      offline: {
        offline_zero: 'Sin sensores desconectados',
        offline_one: '{{count}} sensor desconectado',
        offline_other: '{{count}} sensores desconectados',
      },
      active: {
        active_zero: 'Sin sensores activos',
        active_one: '{{count}} sensor activo',
        active_other: '{{count}} sensores activos',
      },
      no_data: {
        no_data_zero: 'Ningún sensor sin datos',
        no_data_one: '{{count}} sensor sin datos',
        no_data_other: '{{count}} sensores sin datos',
      },
    },
    fallback: {
      alarms: 'Error al cargar datos del alarmas',
      events: 'Error al cargar datos del eventos',
      sensors: 'Error al cargar datos del sensores',
      models: 'Error al cargar datos del modelos',
    },
  },
  breadcrumb: {
    go_back: 'Regresar',
  },
  footer: {
    my_requests: 'Mis solicitudes',
  },
  header: {
    asset_tree: {
      title: 'Árbol de activos',
      open_editing_mode: 'Abrir modo de edición',
      exit_editing_mode: 'Salir del modo de edición',
    },
    tab_menu: {
      alarms: 'Alarma',
      events: 'Alarma',
      sensors: 'Sensor',
      vet: 'VET',
      monitoring: 'Monitoramento',
      models: 'Modelo',
      overview: 'Visión general',
      users_and_roles: 'Usuários y Roles',
      access_levels: 'Niveles de Acceso',
      notifications: 'Notificaciones',
      deviations: 'Condición de desviación',
      reports: 'Informe',
      health: 'Salud del activo',
      oil_system: 'Performance',
    },
  },

  user_menu: {
    greeting: 'Hola, {{user}}',
    exit: 'Salir',
    language: {
      'pt-BR': 'Português',
      es: 'Español',
      en: 'English',
    },
    users_and_permissions: 'Usuarios y permisos',
    notifications: 'Notificaciones',
    sound_alert: 'Alerta sonora',
    help: 'Ayuda',
  },

  image_uploader: {
    action: {
      select: 'Seleccione una imagen',
      send: 'Enviar',
      delete: 'Eliminar',
    },
    title: 'Upload de imagem',
    tooltip: 'Seleccione una imagen para habilitar el botón enviar',
  },
  login: {
    email: 'E-mail',
    login_btn: 'Proceder',
  },
  private_route: {
    confirm: 'OK',
    message: {
      access_denied: {
        title: 'Acceso denegado',
        message: 'No tienes permiso para acceder a esta función',
      },
    },
  },
  pump_curve_graph: {
    updated_at: 'Datos de {{timestamp}}',
    update_rate: 'Actualizado cada {{interval}} {{unit}}',
    no_timeline_data_for_the_selected_period:
      'No hay datos de la línea de tiempo para el período seleccionado',
    legend: {
      rotation: 'Rotación',
      pump_operation: 'Funcionamiento bomba',
      optimal_range: 'Operación ideal',
    },
  },
  sensors_graph: {
    legend: {
      data: 'Datos',
      threshold: 'Limites',
      risk_area: 'Período de riesgo',
      alarm: 'Alarma + período de riesgo',
    },
    no_value: 'Sin valor',
    clear_zoom: 'Limpiar zoom',
    message: {
      no_sensors_selected: {
        title: 'Ningún sensor seleccionado',
        message: 'Seleccione al menos un elemento',
      },
      no_data: {
        title: 'Datos no encontrados',
        message: 'Aplica otros filtros o vuelve a intentarlo en unos minutos',
      },
      generic_error: {
        title: 'Ops..',
        message: 'Ha ocurrido un error inesperado. Espera unos minutos e inténtalo de nuevo',
      },
    },
    tabs: {
      sensors: 'Sensores',
      features: 'Características',
    },
  },
  radar_graphic: {
    title: 'Radar view',
    message: {
      no_data: {
        title: 'Datos no encontrados',
        message: 'Aplica otros filtros o vuelve a intentarlo en unos minutos',
      },
    },
  },
  line_chart: {
    title: 'Grafico de linha',
    no_data: 'Datos no encontrados',
    error: 'An error occurred while loading the data, please try again later',
  },
  plot_scaling: {
    title: 'Vista gráfica',
    legend: {
      no_alarming: 'No Alarming',
      warning: 'Warning',
      learned_region: 'Learned Region',
      alarming: 'Scaling Alarm',
    },
    tooltip: {
      date: 'Fecha y hora',
      itens: 'Elementos Agrupados',
    },
    message: {
      model_version: 'Versión del modelo',
      selected_period_is_older:
        'El período seleccionado es más antiguo que la versión del modelo y no se mostrará por completo',
    },
  },
  authorized_users: {
    tabs: {
      authorized_users: 'Usuarios Autorizados',
      groups: 'Grupos',
    },
    table_headers: {
      name: 'Nombre',
      email: 'Email',
      roles: 'Roles',
      groups: 'Grupos',
      created: 'Creado',
      status: 'Estado',
    },
    chars_limit: 'Límite de 24 caracteres',
    add_user: 'Adicionar Usuario',
    select_roles: 'Selecione roles',
    select_value_to_save: 'Seleccione un valor para salvar',
    modal: {
      add_user: 'Adicionar Usuario',
      name: 'Nombre',
      enter_name: 'Ingrese Nombre',
      email: 'Email',
      users: 'Usuarios',
      enter_email: 'Ingrese Email',
      roles: 'Roles',
      enter_roles: 'Ingresar roles',
      required_field: 'Esse campo é obrigatório',
    },
    roles_success: 'Los roles de usuario se editaron con éxito',
    roles_group_success: 'Los roles de usuario se editaron con éxito',
    group_data_success: 'Los datos del grupo se editaron con éxito',
  },
  user_groups: {
    group_name: 'Nombre del grupo',
    users: 'Usuarios',
    roles: 'Roles',
    status: 'Status',
    placeholder: 'Escribir o colar emails de usuarios',
    add_user_to_group: 'Adicionar usuarios ao grupo',
    delete_user_from_group: 'Eliminar usuario del grupo',
    cancel: 'Cancelar',
    yes_delete_user: 'Si, deletar usuario',
    delete: 'Deletar',
    from_group: 'del grupo',
    new_group: 'Nuevo Grupo',
    add_group: 'Adicionar Grupo',
    no_users: 'No Usuarios',
  },
  access_levels: {
    table_headers: {
      group: 'Grupo',
      attribute: 'Atributo',
      values: 'Valores',
    },
    select_group: 'Seleccione un grupo',
    select_attribute: 'Seleccione un atributo',
    select_values: 'Seleccione os valores',
  },

  notifications: {
    title: 'Tus Notificaciones de Alarma',
    empty: 'No hay más notificaciones configuradas. Puedes ',
    emptyLink: 'agregar una nueva notificación.',
    item: 'notificación',
    columns: {
      email: 'Email',
      whatsapp: 'Whatsapp',
      frequency: 'Frecuencia',
      model: 'Modelo',
      asset: 'Activo',
      edit: '',
      description: 'Descripción',
      subjects: 'Notificaciones',
    },
    alarm_type: {
      model: 'Modelo',
      category: 'Categoría',
      all: 'Todos',
    },
    frequency: {
      daily: 'Diario',
      mondays: 'Lun',
      tuesdays: 'Mar',
      wednesdays: 'Mie',
      thursdays: 'Jue',
      fridays: 'Vie',
      saturdays: 'Sab',
      sunday: 'Dom',
      by_asset: 'Por Activo',
    },
    form: {
      title: 'Añadir nuevo',
      labels: {
        email: 'Email',
        whatsapp: 'Whatsapp',
        frequency: 'Frecuencia',
        model: 'Seleccionar un Modelo',
        asset: 'Seleccionar un Activo',
        switchOn: 'ENCENDIDO',
        switchOff: 'APAGADO',
      },
      placeholders: {
        modelWithoutAsset: 'Esperando selección de activo',
      },
      buttons: {
        add: 'Añadir',
        save: 'Guardar',
        edit: 'Editar',
        duplicate: 'Duplicar',
        delete: 'Eliminar',
      },
    },
  },
  Case: { ...caseTranslations.status, ...caseTranslations.severity },
  ConditionDeviation: {
    openAsset: 'abrir activo',
    newCd: 'Nuevo DC',
    openNewCD: 'Crear nueva Desviación de Condición',
    editCD: 'Editar Desviación de Condición',
    asset: 'Activo',
    asset_id: 'ID de lo Activo',
    dimension: 'Dimensión',
    category: 'Categoría',
    category_id: 'Id de la categoría',
    detection_method: 'Método de detección',
    deviation_start: 'Inicio de desviación',
    deviation_end: 'Fin de desviación',
    duration: 'Duración',
    diagnosis: 'Diagnóstico',
    detailing: 'Detalle',
    recommended_action: 'Acciones recomendadas',
    actionStatus: 'Estado de la acción',
    sap_note: 'Nota',
    sapNoteTooltip: 'El campo de nota es obligatorio con el estado de acción "Acción emitida"',
    assetConditionEvaluation: 'Evaluación de condición',
    condition_evaluation: 'Evaluación de condición',
    assetStatus: 'Estado del activo',
    savings: 'Ahorros',
    savings_required: 'Ahorros',
    savingsNoteTooltip: 'Ahorros es un campo opcional y se puede completar en cualquier momento',
    description: 'Descripción',
    equipment_class: 'Clase de activo',
    subunit: 'Subunidad',
    maintainable_item: 'Elemento mantenible',
    failureMode: 'Modo de fallo',
    failure_mechanism: 'Mecanismo de fallo',
    maintenance_scope: 'Alcance del mantenimiento',
    noFillesAttached: 'No hay archivos adjuntos',
    attachFile: 'Adjuntar archivo',
    alarmsLinked: '{{alarmsCount}} Alarmas vinculadas',
    toThisCD: 'a esta Desviación de Condición',
    addViewAlarms: 'Añadir/ver asset Alarmas de activos',

    is_out_of_service: '¿El equipo puede operar?',
    outOfServiceOptions: {
      yes: 'Capaz de operar',
      no: 'Incapaz de operar',
    },
    options: {
      action_status: {
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Acción emitida',
        CANCELED: 'Cancelado',
        UNDER_EVALUATION: 'En evaluación',
        COMPLETED: 'Completado',
      },
      condition_evaluation: {
        NORMAL_CONDITION: 'Normal',
        ALARM_CONDITION: 'Medio',
        CRITICAL_CONDITION: 'Alto',
        POTENTIAL_PROBLEM: 'Muy Alto',
        NOT_MONITORED: 'No Monitoreado',
        NOT_OPERATED: 'No Operado',
        modec: {
          NORMAL_CONDITION: 'Condição Normal',
          ALARM_CONDITION: 'Condição de Alarme',
          CRITICAL_CONDITION: 'Condição Crítica',
          POTENTIAL_PROBLEM: 'Problema Potencial',
          NOT_MONITORED: 'No Monitoreado',
          NOT_OPERATED: 'No Operado',
        },
      },
      dimensions: {
        AUXILIARY_SYSTEM: 'Sistema auxiliar',
        PROCESS_CONDITION: 'Condición de proceso',
        DYNAMIC_CONDITION: 'Condición dinámica',
        OIL_ANALYSIS: 'Análisis de petróleo',
      },
    },
    confirmChangeAsset:
      'Si cambia el Activo, las alarmas vinculadas se borrarán. ¿Continuar de todos modos?',
    yesContinue: 'Sí, continuar',
    save: 'Guardar',
    placeholders: {
      assetName: 'Seleccionar activo',
      dimension: 'Seleccionar dimensión',
      selectAnOption: 'Seleccionar una opción',
      select: 'Seleccionar',
      dayHour: 'Elegir día y hora',
      diagnosis: 'Introducir diagnóstico de desviación',
      detailing: 'Introducir detalles',
      recommendedActions: 'Introducir recomendaciones',
      sapCode: 'Introducir Nota',
      description: 'Un breve resumen sobre el evento de ahorro',
    },
    messages: {
      duplicate_attribute_name: 'Nombre de atributo duplicado',
      only_numbers: 'Sólo números',
      toBeRequired: 'Este campo es obligatorio',
      confirmTurnOffCannotOperate:
        '¿Está seguro de que desea APAGAR el estado NO PUEDE FUNCIONAR para este equipo?',
      confirmTurnOnCannotOperate:
        '¿Está seguro de que desea ACTIVAR el estado NO PUEDE FUNCIONAR para este equipo?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    modalTitles: {
      new: 'Crear nueva Desviación de Condición',
      edit: 'Desviación de Condición',
    },
    conditionEvaluation: {
      POTENTIAL_PROBLEM: 'Alto',
      CRITICAL_CONDITION: 'Muy Alto',
      ALARM_CONDITION: 'Medio',
      NORMAL_CONDITION: 'Bajo',
    },
  },
  upload: {
    attach_file: 'Adjuntar archivo',
    infoText:
      'Formatos de archivo permitidos: {{acceptFiles}} con tamaño de hasta {{maxFileSize}}Mb',
    noFillesAttached: 'No hay archivos adjuntos',
    errorFiles: 'Solo puedes adjuntar un archivo a la vez',
    duplicatedFile: 'Este archivo ya está adjunto',
    maxFileSize: 'El tamaño del archivo excede el límite de {{maxFileSize}}Mb',
    invalidFormat: 'Formato de archivo inválido. Formatos permitidos: {{acceptFiles}}',
    snackbar: {
      success: { title: 'Carga de Archivo', text: 'carga exitosa' },
      error: { title: 'Carga de Archivo', text: 'error en la carga' },
    },
    error: 'Error',
    add: {
      title: 'Archivo añadido',
      text: 'Archivo añadido con éxito, la carga se realizará al guardar',
    },
    deleteModal: {
      title: 'Eliminar archivo',
      text: 'Este archivo se eliminará permanentemente y no se podrá recuperar',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      snackbar: {
        success: { title: 'Archivo Eliminado', text: 'Archivo eliminado con éxito' },
        error: { title: 'Archivo no Eliminado', text: 'Error al eliminar' },
      },
    },
  },
  list: { chart: 'Gráfico', noData: 'No se encontraron datos para esta sección' },
  inputs: {
    required_field: 'Este campo es obligatorio',
    invalid_date: 'Fecha no válida',
  },
  statusSelectWithButton: {
    label: {
      save: 'Guardar',
      saved: 'Guardado',
      selectPrefix: 'Etapa:',
      cancel: 'Cancelar',
      saveDescription: 'Guardar descripción',
    },
  },
  noData: 'No hay datos',
  caseListItem: {
    options: {
      dimensions: {
        auxiliary_system: 'Sistema Auxiliar',
        process_condition: 'Condición de Proceso',
        dynamic_condition: 'Condición Dinámica',
        oil_analysis: 'Análisis de petróleo',
      },
    },
  },
  external_reference: {
    type: {
      '': 'Seleccione ref.',
      SAP: 'Nota SAP',
      OTHER: 'Otro',
    },
    type_label: 'Referencia externa',
    code_label: 'Codigo de referencia externa',
    placeholders: {
      selectReference: 'Seleccione ref.',
      enterCode: 'Introducir código',
    },
  },
  status_indicators: {
    models_alarming: 'Modelos alarmando',
    cases_opened: 'Casos abiertos',
  },
  custom_toolbar: {
    headings: {
      1: 'Título 1',
      2: 'Título 2',
      3: 'Título 3',
      4: 'Título 4',
      5: 'Título 5',
      6: 'Título 6',
      normal: 'Normal',
    },
  },
};
